import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { Flex, Icon, Text } from '@nula/core-ui';
import { getEntityKindMeta } from '@/utils/entity-kind-meta';
import type { SurfaceEntry } from '@/lib/sync/document-surfaces';
import { surfaceMeta } from '@/lib/sync/surface-meta';
import styles from './surface-label.module.css';

interface SurfaceLabelProps {
  bodyTitle: string;
  entry: SurfaceEntry | null;
  onClick: () => void;
  className?: string;
}

const label = cva(styles.label);

/**
 * The closed-panel pill beside the orb, naming the current surface. Decorative:
 * `SurfaceOrbButton`'s own accessible name already states "Surfaces, N" (or
 * the per-surface state), so this duplicate visual affordance is
 * `aria-hidden` and out of the tab order rather than a second control naming
 * the same thing.
 */
export function SurfaceLabel({ bodyTitle, entry, onClick, className }: SurfaceLabelProps) {
  const meta = entry ? surfaceMeta(entry) : getEntityKindMeta('document');
  const name = entry ? entry.title : bodyTitle;

  return (
    <Flex
      aria-hidden="true"
      tabIndex={-1}
      onClick={onClick}
      className={clsx(label(), className)}
    >
      <Icon name={meta.icon} size={18} className={styles.icon} />
      <Text className={styles.name}>{name}</Text>
    </Flex>
  );
}
